import React, { useState } from 'react'
import ChevronIcon from '../icons/ChevronIcon';
import { parseUpdateParagraph } from '../../utils/parseUpdateParagraph';

type FAQProps = {
    heading: string,
    body: [string, string][],
    open?: boolean
}

const Information_FAQ = ({ open = false, heading, body }: FAQProps) => {

    const [isOpen, setIsOpen] = useState(open);
  
    return (
        <div className='mb-4 md:mb-8'>
            <div className="flex justify-between cursor-pointer" onClick={() => setIsOpen(!isOpen)} >
                <h2 className="font-light mb-2">{heading}</h2>
                <ChevronIcon size={6} rotate={isOpen} />
            </div>
    
            <div className={isOpen ? "accordion open" : "accordion"}>
            <div className="accordion-inner">
                {
                    body.map(
                        ([key, val], i) => parseUpdateParagraph(val, key, "paragraph fade-item", {"--i": i} as React.CSSProperties)
                    )
                }
            </div>
            </div>
        </div>
    );
};

export default Information_FAQ
